import _initializerDefineProperty from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _createClass from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";

var _dec, _dec2, _class, _descriptor, _descriptor2;

import { wrapperGet, wrapperPost } from '@/utils/http';
import { setRequestHeaderDecorator } from 'decor-core';
import { getSessionStorageKey } from '@/utils/utils';
var setRequestConfig = {
  actChannel: getSessionStorageKey('activityKey') || null
};
export default new (_dec = setRequestHeaderDecorator(setRequestConfig), _dec2 = setRequestHeaderDecorator(setRequestConfig), (_class = /*#__PURE__*/_createClass(function UserApi() {
  _classCallCheck(this, UserApi);

  _defineProperty(this, "thirdViewByPlatform", wrapperPost('/api/opuser/thirdViewByPlatform'));

  _defineProperty(this, "sendSmsCode", wrapperPost('/api/client-ubq-app/auctionMarket/sendBiddingSmsCode'));

  _defineProperty(this, "sendSmsCodeBatch", wrapperPost('/api/client-ubq-app/message/sms/send'));

  _defineProperty(this, "getFuYouWallet", wrapperGet('/api/opuser/getFuYouWallet'));

  _defineProperty(this, "refreshesWallet", wrapperGet('/api/opuser/refreshesWallet'));

  _initializerDefineProperty(this, "activeLogin", _descriptor, this);

  _initializerDefineProperty(this, "activeRegister", _descriptor2, this);

  _defineProperty(this, "loginByCode", wrapperPost('/api/opuser/loginCode'));

  _defineProperty(this, "getTradePasswordStatus", wrapperGet('/api/opuser/tradePasswordStatus'));

  _defineProperty(this, "setTradePassword", wrapperPost('/api/opuser/setTradePassword'));

  _defineProperty(this, "logout", wrapperGet('/api/opuser/logout'));

  _defineProperty(this, "getRealNameInfo", wrapperGet('/api/opuser/realNameAuth'));

  _defineProperty(this, "getUserInfo", wrapperGet('/api/opuser/checkToken'));

  _defineProperty(this, "resetValidateCode", wrapperPost('/api/opuser/validateCode'));

  _defineProperty(this, "newPwdLogin", wrapperPost('/api/opuser/resetPassByCode'));

  _defineProperty(this, "register", wrapperPost('/api/opuser/signUpOrLogin'));

  _defineProperty(this, "login", wrapperPost('/api/opuser/loginPassword'));

  _defineProperty(this, "getVerifyCode", wrapperGet('/api/opuser/getCodeNoAuth'));

  _defineProperty(this, "getAppVerifyCode", wrapperGet('/api/opclearing/account/getCode'));

  _defineProperty(this, "userSubmitCode", wrapperPost('/api/opuser/user/submitCode'));

  _defineProperty(this, "userWallet", function (currencyKind) {
    return wrapperGet("/api/opuser/userWallet/".concat(currencyKind));
  });
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "activeLogin", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperPost("/api/opuser/loginPassword");
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "activeRegister", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperPost("/api/opuser/signUpOrLogin");
  }
})), _class))();